import { Injectable } from '@angular/core';
import { EventDelegatorService } from '@services/event-delegator.service';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  constructor(
    public eventDelegatorService: EventDelegatorService
  ) {}

  private subject = new Subject<any>();

  show() {
    this.subject.next(true);
  }
  hide() {
    this.subject.next(false);
  }

  // Works for Angular requests only
  // public readonly spinner$ = defer(() => {
  //     this.show();
  //     return NEVER.pipe(
  //       finalize(() => {
  //         this.hide();
  //       })
  //     );
  // }).pipe(share());

  getLoader(): Observable<any> {
    return this.subject.asObservable();
  }
}
